export default "__VITE_ASSET__49b8ff70__"